export const CONSTANTS = {
  features: [
    {
      label: "Strategic Locations",
      text: "Gain access to multiple high-performance data centers, with global expansion—ensuring optimal reach and low-latency connectivity wherever you operate. ",
    },
    {
      label: "Enterprise-Grade Infrastructure",
      text: "Our facilities are built for resilience, with redundant power, cooling, and networking systems designed to support mission-critical workloads without compromise.",
    },
    {
      label: "End-to-End Security",
      text: "Protect your assets with multi-layered physical and digital security, along with compliance-ready environments that meet stringent industry standards.",
    },
    {
      label: "Scalable by Design",
      text: "From startups to enterprises, our flexible colocation models scale with your business—whether you're housing a few servers or full racks.",
    },
    {
      label: "Cost-Efficient Flexibility",
      text: "Enjoy transparent pricing with no long-term lock-ins. Our models are built to align with your financial goals while delivering enterprise reliability.",
    },
  ],
  title: "Why Choose OneMind for Colocation?",
};
